export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes";
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = "c380fb9a-c1db-4461-ae87-36cfe04e32df";
export const MODAL_CLOSE_SEC = 2.5;
